import React from "react";
import { AlertTriangle, CheckCircle2, Calculator } from "lucide-react";
import { formatEUR } from "@/lib/api";

/* Eenvoudige uurtarief-kostencheck: (lonen + vaste kosten) / productieve uren = kostprijs per uur; + gewenste winst = minimaal tarief. */
export function RateCheck({ form, t }) {
  const wages = Number(form.cost_wages_month) || 0, fixed = Number(form.cost_fixed_month) || 0, hours = Number(form.productive_hours_month) || 0, profit = Number(form.target_profit_pct) || 0;
  if (hours <= 0 || wages + fixed <= 0) return <p className="text-xs text-muted-foreground" data-testid="rate-check-empty">{t("rateCheckEmpty")}</p>;
  const costHour = (wages + fixed) / hours;
  const minRate = costHour * (1 + profit / 100);
  const rows = [["labor_rate", t("rateCar"), Number(form.labor_rate) || 0], ["labor_rate_truck", t("rateTruck"), Number(form.labor_rate_truck) || 0]];
  return (
    <div className="rounded-xl border border-border/60 p-3 space-y-2 text-sm" data-testid="rate-check">
      <div className="flex flex-wrap gap-4 font-mono text-xs">
        <span className="flex items-center gap-1"><Calculator className="h-3.5 w-3.5 text-primary" />{t("costPerHour")}: <b data-testid="rate-check-cost-hour">{formatEUR(costHour)}</b></span>
        <span>{t("minRate")} (+{profit} %): <b data-testid="rate-check-min-rate">{formatEUR(minRate)}</b></span>
      </div>
      {rows.map(([k, label, rate]) => {
        const ok = rate >= minRate, breakEven = rate >= costHour;
        const margin = rate > 0 ? ((rate - costHour) / rate) * 100 : 0;
        return (
          <div key={k} className={`flex items-center justify-between rounded-lg px-3 py-2 ${ok ? "bg-emerald-500/10" : breakEven ? "bg-amber-500/10" : "bg-rose-500/10"}`} data-testid={`rate-check-${k}`}>
            <span className="flex items-center gap-2">{ok ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <AlertTriangle className={`h-4 w-4 ${breakEven ? "text-amber-500" : "text-rose-600"}`} />}{label}: <b className="font-mono">{formatEUR(rate)}</b></span>
            <span className="text-xs font-mono">{margin.toFixed(0)} % {t("marginOnLabor")} · {ok ? t("rateOk") : breakEven ? t("rateLowProfit") : t("rateLoss")}</span>
          </div>
        );
      })}
    </div>
  );
}
